/**
 * The effective-rate rows, ranked.
 *
 * `analytics-effective-rate.ts` answers in slug order, and a bar chart in
 * alphabetical order has no rank at all — DESIGN.md P3 is about showing the
 * exception, and the exception here is whoever is at the bottom. So the rows are
 * sorted worst-last here, once, and the chart, its table view and the export all read
 * the same order. The report asks the read model to sort, as `analytics_client_health`
 * already does.
 *
 * A client with no retainer time has `rate: null` — "never Infinity and never zero",
 * per `ClientEffectiveRateSchema`. There is no bar to draw for one, so they come out
 * separately and are named in the narration line and listed in the table.
 */

import type { RateData } from './data.js'

export type RateRow = RateData['clients'][number]
export type RatedRow = RateRow & { readonly rate: NonNullable<RateRow['rate']> }

export type RankedRates = {
  /** Highest rate first. What the chart draws. */
  readonly rated: readonly RatedRow[]
  /** No retainer time logged this month, so no rate. */
  readonly untimed: readonly RateRow[]
}

export function rankRates(rate: RateData): RankedRates {
  return {
    rated: rate.clients
      .flatMap<RatedRow>((one) => (one.rate === null ? [] : [{ ...one, rate: one.rate }]))
      .sort((a, b) => b.rate.amount - a.rate.amount),
    untimed: rate.clients.filter((one) => one.rate === null),
  }
}
